export function extractInvoicePaymentDetails(invoicePaymentDetails: $TSFixMe) {
  return invoicePaymentDetails.map((i: $TSFixMe) => ({
    status: i.status,
    currency: i.currency_code ? i.currency_code : null,
    dueDate: i.due_date ? i.due_date : null,
    amountDue: i.amount_due ? i.amount_due : null,
  }));
}
